// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"pages-sponsorships-forms-campaignsForm__inputContainer--2rAGQ"};